import { FOCO_VISIVEL } from 'utils/foco';

import { IntegranteDaAcaoEcoa } from '../acoes-do-semestre';
import { ModeloDaAcaoEcoa } from '../andamento-da-acao';

type ModeloDaExclusao = Pick<ModeloDaAcaoEcoa, 'data' | 'canExcludeParticipation' | 'setUserToChange' | 'showModal'>;

/**
 * "Excluir participação" na linha de um integrante do "Ver mais", como o `TaskItemEcoa` oferece ao próprio integrante
 * e ao gestor dele (`canExcludeParticipation`): abre o mesmo modal `team-member-exclude` com a pessoa em
 * `userToChange`. Sem "Reduzir percentual": a ECOA não tem percentual de atuação (ECN-14).
 */
export default function ExclusaoDoIntegrante({ pessoa, modelo }: { pessoa: IntegranteDaAcaoEcoa; modelo: ModeloDaExclusao }) {
  if (!modelo.canExcludeParticipation(pessoa)) return null;

  const nome = pessoa.extra?.nome_guerra?.split(' ')[0] || pessoa._id;

  return (
    <button
      type="button"
      aria-label={`Excluir participação de ${nome}`}
      onClick={() => {
        modelo.setUserToChange(pessoa._id);
        modelo.showModal(`team-member-exclude-${modelo.data._id}`);
      }}
      className={`cursor-pointer border-0 bg-transparent p-0 text-[11px] font-bold uppercase tracking-[0.04em] text-urgent hover:underline ${FOCO_VISIVEL}`}
    >
      Excluir participação
    </button>
  );
}
